<template>
  <section>
    <qx-search-box
      class="searchBox"
      ref="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    >
      <el-alert
        show-icon
        :closable="false"
        title="温馨提示：应付预期是指由于特殊原因导致欠款未给车队退款的金额。"
        type="warning"
      />
    </qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        businessNumberOptions: [],
        stateOptions: [],
        form: [
          { // 订单号
            label: '订单号',
            value: 'orderId',
            type: 'input',
            placeholder: '请输入订单号',
          },
          { // 付款方
            label: '付款方',
            value: 'name',
            type: 'input',
            placeholder: '请输入付款方',
          },
          { // 业务
            label: '业务',
            value: 'businessNumber',
            type: 'select',
            placeholder: '请选择业务',
            default: '',
          },
          { // 状态
            label: '状态',
            value: 'state',
            type: 'select',
            placeholder: '请选择状态',
            default: '',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      searchBoxData.month = this.formatDate(searchBoxData.month, 3);
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'APP_BUSINESS_OVERDUE,APP_BSUBJECTS_OVERDUE',
    });
    this.searchBoxData.businessNumberOptions = [
      {
        label: '全部',
        value: '',
      },
      ...enumsList[0],
    ];
    this.searchBoxData.stateOptions = [
      {
        label: '全部',
        value: '',
      },
      ...enumsList[1],
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
